import React from 'react';
import ErrorMessage from '../ErrorMessage';

/**
 * ErrorRow component
 *
 * Renders an explanatory message in two different presentations:
 *
 * 1. **Stand-alone empty-state** – a self-contained table used when the entire
 *    view has no data (`standalone = true`). The message is centered both
 *    vertically and horizontally.
 * 2. **Inline error row** – a single `<tr>` that spans the current table,
 *    shown when only one row is invalid or cannot be rendered
 *    (`standalone = false`, the default).
 *
 * Props
 * @param {string}  message             Text to display.
 * @param {number}  columns             Number of columns in the parent table
 *                                      (used for the inline variant’s `colSpan`).
 * @param {boolean} [standalone=false]  If `true`, renders the stand-alone variant.
 *
 * @returns {JSX.Element}
 */
const ErrorRow = ({ message, columns, standalone = false }) => {
  // Stand-alone empty-state (full-width table)
  if (standalone) {
    return (
      <table className="w-full table-fixed">
        <tbody>
          <tr>
            <td className="relative overflow-hidden py-8 px-4">
              <ErrorMessage
                message={message}
                className="
                  break-words whitespace-normal text-center
                  left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
                "
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  // Inline error row (inside existing table)
  return (
    <tr>
      <td colSpan={columns} className="relative py-8 px-2">
        <ErrorMessage message={message} className="break-words whitespace-normal text-center" />
      </td>
    </tr>
  );
};

export default ErrorRow;
